import * as React from 'react';
import { Row, Col, Button } from 'antd';
import TableFilterContextProvider from 'components/Forms/DataGrid/TableFilterContextProvider';
import { JcsdAccountListFilterBar, JcsdAccountListTable } from '.';
import { RouteComponentProps } from 'react-router-dom';
import { withRouter } from 'react-router';
import DetailsData from 'Core/models/DetailsData';
import DetailsMode from 'Core/models/DetailsMode';
import { RightAlignedRow } from 'components/Styled/Layout/RightAlignedRow';
import { LeftAlignedRow } from 'components/Styled/Layout/LeftAlignedRow';
import { CenteredContent } from '../../Layout/RegisterLayout/RegisterLayout.Style';
import { WhiteBackgroundCard } from '../../Forms/Form.Styled';

export interface Props extends RouteComponentProps {
    children?: React.ReactNode;
}

export interface State { }

export class JcsdAccountListViewWithoutRouter extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {};
    }

    AddNewJcsdAccount = () => {
        const newDetailsData = new DetailsData();
        newDetailsData.mode = DetailsMode.New;
        this.props.history.push('accounts/wizard', newDetailsData);
    };

    render() {
        return (
            <WhiteBackgroundCard>
                <TableFilterContextProvider>
                    <LeftAlignedRow>
                        <Col>
                            <Button size="large" type="primary" onClick={this.AddNewJcsdAccount}>
                                Add Account
            </Button>
                        </Col>
                    </LeftAlignedRow>
                    <Row>
                        <Col md={24}>
                            <JcsdAccountListFilterBar />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={24}>
                                <JcsdAccountListTable  />                            
                        </Col>
                    </Row>
                </TableFilterContextProvider>
            </WhiteBackgroundCard>
        );
    }
}

const JcsdAccountListView = withRouter(JcsdAccountListViewWithoutRouter);

export default JcsdAccountListView;



